<template>
  <div class="notification" :class="{ active: visible }">
    <div class="call_info">
      <img :src="callData.avatar || avatar" alt="" />
      <div class="user">
        {{ callData.sendUserNickName }}
        <span>{{
          !callData.isVideoCall ? "邀请你语音通话" : "邀请你视频通话"
        }}</span>
      </div>
    </div>
    <div class="btns">
      <div class="qiehuan" @click="turnOn(2)" v-if="callData.isVideoCall">
        <div class="switch"><i class="iconfont iconqiehuanyuyin"></i></div>
        切到语音接听
      </div>
      <div class="rightbtn">
        <div class="hangup" @click="reject">
          <i
            style="font-size: 34px; line-height: 27px"
            class="iconfont icondianhua_tianchong"
            title="挂断"
          ></i>
        </div>
        <div class="answer">
          <i
            @click="turnOn(1)"
            v-if="callData.isVideoCall"
            class="iconfont iconshipin2"
            title="接听"
          ></i>
          <i
            @click="turnOn(2)"
            v-else
            class="iconfont iconlujing"
            title="接听"
          ></i>
        </div>
      </div>
    </div>
    <div v-if="visible">
      <audio
        v-show="false"
        controls
        :src="require('@/assets/audio/incoming_call_ring.mp3')"
        loop="loop"
        autoplay="autoplay"
      ></audio>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import store from "@/store/";

export default {
  data() {
    return {
      visible: false,
      callData: {},
      avatar: require("@/assets/img/user.png"),
      url: {
        // reject: '/daxiang-cloud/platform/video_call/receive_reject',
        reject: "/user/api/video_call/receive_reject",
      },
    };
  },
  computed: {
    userId() {
      return store.state.userInfo.id;
    },
  },
  watch: {
    userId(val) {
      console.log(val);
      this.initWebSocket(val);
    },
  },
  // mounted() {
  //   setTimeout(() => {
  //     console.log(store.state.userInfo)
  //     if (store.state.userInfo.id) this.initWebSocket()

  //   }, 1000);
  // },
  methods: {
    init(data) {
      data.typeCode = "receiver";
      data.isVideoCall = JSON.parse(data.isVideoCall);
      this.callData = data;
      this.visible = true;
      // setTimeout(()=>{
      //   this.reject()
      // },120000)
    },
    close() {
      this.visible = false;
    },
    // 拒绝
    reject() {
      let params = {
        sendUserId: this.callData.sendUserId,
      };
      getAction(this.url.reject, params);
      this.close();
    },
    // 接听
    turnOn(type) {
      console.log(type);
      if (type == 1) this.callData.callType = "video";
      if (type == 2) this.callData.callType = "audio";
      this.$emit("ok", this.callData);
      this.close();
    },
    // 来电
    incomingcall(data) {
      console.log(data);
      let businessData = JSON.parse(data.businessData);
      if (businessData && businessData.type == "order")
        sessionStorage.setItem("orderId", businessData.businessId);
      // 接收方来电显示
      if (data.businessType == "videoCall") {
        this.init(data);
      }
      // 发起方挂断
      if (data.businessType == "videoCallCancel") {
        this.$notify.closeAll()
        this.$emit("hangup", data);
        this.$notify.info({
          title: "提示",
          message: "已挂断！",
        });
        this.close();
      }
      // 接收方挂断
      if (data.businessType == "videoCallHangup") {
        this.$notify.closeAll()
        this.$emit("hangup", data);
        this.$notify.info({
          title: "提示",
          message: "对方已挂断！",
        });
        this.close();
      }
    },
    //WebSocket
    initWebSocket: function (id) {
      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
      var userId = store.state.userInfo.id;
      var url =
        process.env.VUE_APP_BASE_API.replace("https://", "wss://").replace(
          "http://",
          "ws://"
        ) +
          "/admin/websocket/" +
          id || userId;
      //console.log(url);
      this.websock = new WebSocket(url);
      this.websock.onopen = this.websocketOnopen;
      this.websock.onerror = this.websocketOnerror;
      this.websock.onmessage = this.websocketOnmessage;
      this.websock.onclose = this.websocketOnclose;
    },
    websocketOnopen: function () {
      console.log("WebSocket连接成功");
      //心跳检测重置
      //this.heartCheck.reset().start();
    },
    websocketOnerror: function (e) {
      console.log("WebSocket连接发生错误");
      this.reconnect();
    },
    websocketOnmessage: function (e) {
      console.log("-----接收消息-------", e.data);
      var data = eval("(" + e.data + ")"); //解析对象
      if (data.businessType) {
        this.incomingcall(data);
      }
      // if (data.cmd == 'topic') {
      //   //系统通知
      //   this.loadData()
      // } else if (data.cmd == 'user') {
      //   //用户消息
      //   this.loadData()
      // }
      //心跳检测重置
      //this.heartCheck.reset().start();
    },
    websocketOnclose: function (e) {
      console.log("connection closed (" + e + ")");
      if (e) {
        console.log("connection closed (" + e.code + ")");
      }
      this.reconnect();
    },
    websocketSend(text) {
      // 数据发送
      try {
        this.websock.send(text);
      } catch (err) {
        console.log("send failed (" + err.code + ")");
      }
    },
    reconnect() {
      var that = this;
      if (that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        console.info("尝试重连...");
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
  },
};
</script>

<style lang='scss' scoped>
.iconguaduan {
  font-size: 12px;
}

.notification {
  position: fixed;
  width: 300px;
  height: 103px;
  right: -500px;
  top: 63px;
  z-index: 5000;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 2px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.active {
    right: 25px;
  }

  .call_info {
    height: 36px;
    display: flex;

    img {
      width: 36px;
      height: 36px;
      border-radius: 2px;
      margin-right: 10px;
    }

    .user {
      color: #333333;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      span {
        color: #999999;
        line-height: 12px;
      }
    }
  }

  .btns {
    display: flex;
    height: 30px;
    position: relative;

    .iconfont {
      color: #fff;
    }

    .switch,
    .hangup,
    .answer {
      border-radius: 50%;
      width: 30px;
      height: 30px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }

    .qiehuan {
      color: #999;
      line-height: 16px;
      display: flex;
      align-items: center;
      cursor: pointer;

      .switch {
        background: #c8cacc;
        margin-right: 10px;
      }

      .icon-qiehuanyuyin {
        color: #fff;
      }
    }

    .rightbtn {
      width: 72px;
      display: flex;
      position: absolute;
      right: 0;
      justify-content: space-between;

      .hangup {
        background: #f95151;
      }

      .answer {
        background: #01c160;
      }
    }
  }
}
</style>